import { render, staticRenderFns } from "./index.vue?vue&type=template&id=605a1e05&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=605a1e05&prod&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=605a1e05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_abc276eb37b0b1314bfe9ec856cc5e10/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605a1e05",
  null
  
)

export default component.exports